import { render, staticRenderFns } from "./ChangeRentRate.vue?vue&type=template&id=2ef5b06e&"
import script from "./ChangeRentRate.vue?vue&type=script&lang=js&"
export * from "./ChangeRentRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports